export default __webpack_public_path__ + "static/media/closet5-before3-1920w.64772808.webp";